export default __webpack_public_path__ + "static/media/h2a1.cb3e98ad.jpg";